import React, { useState, useEffect } from 'react'
import { format, addDays } from 'date-fns'
import { NavSubDaily } from '@foodsby/nutrient-v3'

const DayPicker = ({
  todaysDate = format(new Date(), 'MM/DD/YYYY'),
  selectedDate,
  onChangeDay,
}) => {
  const numDays = 7
  const [days, setDays] = useState([])
  const [controlledIndex, setControlledIndex] = useState(-1)

  useEffect(() => {
    const tempDays = [...Array(numDays).keys()]
    const days = tempDays.map(n => {
      const date = addDays(todaysDate, n)
      return {
        day: format(date, 'dd')[0],
        selectedDate: format(date, 'YYYYMMDD'),
      }
    })

    setDays(days)
  }, [todaysDate])

  useEffect(() => {
    const index = days?.findIndex(d => d?.selectedDate === selectedDate)
    if (index >= 0 && index < numDays) {
      setControlledIndex(index)
    }
  }, [days, selectedDate])

  return (
    <NavSubDaily
      className="NutrientV3"
      controlledIndex={controlledIndex}
      days={days}
      onChange={day => {
        day.selectedDate !== selectedDate && onChangeDay(day.selectedDate)
      }}
    />
  )
}

export default DayPicker
